export default {"src":"/_next/static/media/CreateProduct.7e266454.svg","height":80,"width":80,"blurWidth":0,"blurHeight":0};